import { render, staticRenderFns } from "./index.vue?vue&type=template&id=35ae537c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=35ae537c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ae537c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/.jenkins/workspace/crm-ui/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35ae537c')) {
      api.createRecord('35ae537c', component.options)
    } else {
      api.reload('35ae537c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=35ae537c&scoped=true&", function () {
      api.rerender('35ae537c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageTable/index.vue"
export default component.exports